import { Box } from '@mui/material';
import { getAllSigners } from 'lib/api/business';
import { GetAllSignersResponse } from 'lib/api/business/types';
import GlobalSearcher from 'lib/common/GlobalSearcher';
import { Filter } from 'lib/common/GlobalSearcher/filterTypes';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { errorHandler } from 'lib/functions/errors';
import { Pagination } from 'lib/types/shared';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const BASE_PAGINATION: Pagination = {
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
};

const tableHeaders = [
  { key: 'identifier', label: 'Rut' },
  { key: 'name', label: 'Nombre' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Teléfono' },
  { key: 'company', label: 'Empresa', type: 'dual-text' },
];

const Signers = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<GetAllSignersResponse['data']>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState<Pagination>(BASE_PAGINATION);
  const [identifier, setIdentifier] = useState<string>('');

  const filters: Filter[] = [
    {
      type: 'autocomplete',
      label: 'Empresa',
      key: 'businessIdentifier',
      value: identifier,
      setter: setIdentifier,
    },
  ];

  const generateQuery = ({
    page,
    pageSize,
    identifier,
  }: {
    page: number;
    pageSize: number;
    identifier: string;
  }) => {
    const urlParams = new URLSearchParams();
    if (identifier) urlParams.set('identifier', identifier);
    if (page) urlParams.set('page', page.toString());
    if (pageSize) urlParams.set('pageSize', pageSize.toString());
    return urlParams.toString();
  };

  const fetchSigners = async (params?: { page: number; pageSize: number }) => {
    try {
      setLoading(true);
      const pageToUse = params?.page ?? pagination.page;
      const pageSizeToUse = params?.pageSize ?? pagination.pageSize;
      const query = generateQuery({
        page: pageToUse,
        pageSize: pageSizeToUse,
        identifier,
      });
      const response = await getAllSigners(dispatch, query);
      setData(response?.data ?? []);
      setPagination(response?.pagination ?? BASE_PAGINATION);
    } catch (error) {
      errorHandler(dispatch, error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void fetchSigners({ page: 1, pageSize: 10 });
  }, []);

  return (
    <Box mt={2} position="relative">
      <Box sx={{ position: 'absolute', top: -52, right: 0 }}>
        <GlobalSearcher
          filters={filters}
          triggerSearch={() => fetchSigners()}
          dispatch={dispatch}
        />
      </Box>
      <TableWithPagination
        data={data}
        setData={setData}
        dataHeaders={tableHeaders}
        pagination={pagination}
        setPagination={setPagination}
        loading={loading}
        searchData={fetchSigners}
      />
    </Box>
  );
};

export default Signers;
